import { render } from "./GameCompaign.vue?vue&type=template&id=bb272038"
import script from "./GameCompaign.vue?vue&type=script&lang=js"
export * from "./GameCompaign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__